import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { joinGroupConversation } from "@/api/api";
import ErrorDetails from "@/components/Message/ErrorDetails";
import { getErrorDetails, getErrorSummary } from "@/utils/errorMessages";

const JoinGroupChat = () => {
  const { conversationId } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState<unknown>(null);
  const [errorDetails, setErrorDetails] = useState<ReturnType<typeof getErrorDetails> | null>(null);

  useEffect(() => {
    if (!conversationId) {
      setError("Invalid join link.");
      setErrorDetails(null);
      return;
    }

    joinGroupConversation(conversationId)
      .then((success) => {
        if (success) {
          navigate(`/gc/${conversationId}`, { replace: true });
        } else {
          setError("This link is invalid or the conversation no longer exists.");
          setErrorDetails(null);
        }
      })
      .catch((joinError: unknown) => {
        setError(joinError);
        setErrorDetails(getErrorDetails(joinError));
      });
  }, [conversationId]);

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center h-screen gap-4">
        <div className="text-center text-error" role="alert">
          <p className="text-sm">{errorDetails ? getErrorSummary(error, errorDetails) : String(error)}</p>
          {errorDetails && <ErrorDetails details={errorDetails} error={error} />}
        </div>
        <button type="button" className="btn btn-primary btn-sm" onClick={() => navigate("/")}>
          Go Home
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center h-screen gap-3">
      <div className="loading-icon w-24 h-24"></div>
      <p className="text-sm text-accent">Joining conversation...</p>
    </div>
  );
};

export default JoinGroupChat;
